import React from 'react';
import { Tag, SelectNative, SelectNativeOption } from '@americanexpress/dls-react';
import { useIntl } from 'react-intl';

type FilterButtonsProps = {
  tags: { index: number, categoryName: string }[],
  activeTag: number,
  setActiveTag: (_: number) => void,
};

export const FilterButtons = ({
  tags, activeTag, setActiveTag,
}: FilterButtonsProps) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <div className="row pad-1-b-lg-up pad-1-t-md-down hidden-sm-down">
        <div className="col-sm-12 pad-lr-sm-down">
          {
            tags.map((tag, index) => (
              <Tag
                aria-label={tag.categoryName}
                id={`personalized-marketing-articles-tag-${index}`}
                key={tag.categoryName}
                className="pad-1-r pad-1-b"
                reactlytics={{
                  element: 'personalized-marketing-article-filter',
                  detail: tag.categoryName.toLowerCase(),
                }}
                aria-pressed={activeTag === index}
                onClick={() => setActiveTag(index)}
              >
                {tag.categoryName}
              </Tag>
            ))
          }
        </div>
      </div>
      <SelectNative
        id="filter-by-select"
        className="pad-2-b pad-r hidden-md-up"
        label={formatMessage({ id: 'getInspired.selectCategory' })}
        aria-label={formatMessage({ id: 'getInspired.selectCategory' })}
        status="default"
        value={activeTag}
        onChange={
          (e) => {
            setActiveTag(Number(e.target.value as unknown));
          }
        }
      >
        {
          tags.map((tag, index) => (
            <SelectNativeOption
              key={tag.categoryName}
              value={index}
              aria-label={tag.categoryName}
            >
              {tag.categoryName}
            </SelectNativeOption>
          ))
        }
      </SelectNative>
    </>
  );
};
